export const getters = {
  list: state => state.list,
  staff_salary: state => state.staff_salary,
  inventory: state => state.inventory,
  bonuse_inventory: state => state.bonuse_inventory,
  sanction_inventory: state => state.sanction_inventory,
  model: state => state.model,
  rules: state => state.rules,
  columns: state => state.columns,
  filter: state => state.filter,
  pagination: state => state.pagination,
  sort: state => state.sort 
};
